// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Sidebar_sideBar__eaJIk {
  display: flex;
  flex-direction: column;
  max-width: 300px;
  height: 100vh;
  /* padding: 24px; */
  /* padding-right: 8px !important; */
  background-color: var(--border-green);
  margin: 0px;
  gap: 10px;
  padding: 0px;
}
.Sidebar_sideBar__eaJIk > div {
  padding-inline: 10px;
}
.Sidebar_sidebarLogo__dCHQt {
  height: 140px;
  width: 100%;
  box-shadow: 0px 7px 30px 0px #3745571a;
  display: flex;
  justify-content: center;
  align-items: center;
}
.Sidebar_sidebarLogo__dCHQt img {
  width: 180px;
  height: 100px;
  object-fit: contain;
}

.Sidebar_sideBarTabContainer__aiZKJ {
  display: flex;
  overflow-y: auto;
  flex-direction: column;
  flex: 1 1;
  min-height: 0;
  scrollbar-width: thin;
  scrollbar-color: var(--primary-color) rgba(0, 0, 0, 0.05);
}

.Sidebar_sideBarTabContainer__aiZKJ::-webkit-scrollbar {
  width: 6px;
}

.Sidebar_sideBarTabContainer__aiZKJ::-webkit-scrollbar-track {
  background: rgba(0, 0, 0, 0.05);
  border-radius: 10px;
}

.Sidebar_sideBarTabContainer__aiZKJ::-webkit-scrollbar-thumb {
  background: var(--primary-color);
  border-radius: 10px;
}

.Sidebar_sideBarTabContainer__aiZKJ::-webkit-scrollbar-thumb:hover {
  background: #a0080b;
}

.Sidebar_sideBarTab__RhKkR {
  display: flex;
  padding: 10px 15px;
  margin-right: 16px;
  align-items: center;
  gap: 10px;
}

.Sidebar_sideBarTab__RhKkR[data-active="true"] {
  background: var(--primary-color);
  border-radius: 7px;
  box-shadow: 0px 7px 30px 0px #3745571a;
}

.Sidebar_sideBarTab__RhKkR[data-active="true"] p {
  color: var(--white-color);
}

.Sidebar_sideBarTab__RhKkR p {
  color: var(--gray-v5);
  font-family: "Inter", serif;
  font-size: 16px;
  font-weight: 500;
  margin-bottom: 0px;
}

.Sidebar_sideBarTabIcon__Gm5dy {
  display: flex;
  width: 25px;
  height: 25px;
  justify-content: center;
  align-items: center;
  border-radius: 5px;
  border: 1px solid var(--purple-v1);
  background: #fff;
}

.Sidebar_logoutBtn__lBM\\+V {
  background-color: var(--primary-color);
  color: var(--white-color);
  display: flex;
  height: 45px;
  align-items: center;
  border-radius: 7px;
  gap: 10px;
  cursor: pointer;
  margin: 0px 10px 20px;
}

.Sidebar_logoutBtn__lBM\\+V svg,
.Sidebar_logoutBtn__lBM\\+V span {
  color: var(--white-color);
}

@media screen and (max-width: 1024px) {
  .Sidebar_sideBarTabContainer__aiZKJ {
    gap: 10px;
  }

  .Sidebar_sideBarTab__RhKkR p {
    font-size: 13px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/Components/molecules/SideBar/Sidebar.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,mCAAmC;EACnC,qCAAqC;EACrC,WAAW;EACX,SAAS;EACT,YAAY;AACd;AACA;EACE,oBAAoB;AACtB;AACA;EACE,aAAa;EACb,WAAW;EACX,sCAAsC;EACtC,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,sBAAsB;EACtB,SAAO;EACP,aAAa;EACb,qBAAqB;EACrB,yDAAyD;AAC3D;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,+BAA+B;EAC/B,mBAAmB;AACrB;;AAEA;EACE,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,gCAAgC;EAChC,kBAAkB;EAClB,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,2BAA2B;EAC3B,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,kCAAkC;EAClC,gBAAgB;AAClB;;AAEA;EACE,sCAAsC;EACtC,yBAAyB;EACzB,aAAa;EACb,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,SAAS;EACT,eAAe;EACf,qBAAqB;AACvB;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;EACE;IACE,SAAS;EACX;;EAEA;IACE,eAAe;EACjB;AACF","sourcesContent":[".sideBar {\n  display: flex;\n  flex-direction: column;\n  max-width: 300px;\n  height: 100vh;\n  /* padding: 24px; */\n  /* padding-right: 8px !important; */\n  background-color: var(--border-green);\n  margin: 0px;\n  gap: 10px;\n  padding: 0px;\n}\n.sideBar > div {\n  padding-inline: 10px;\n}\n.sidebarLogo {\n  height: 140px;\n  width: 100%;\n  box-shadow: 0px 7px 30px 0px #3745571a;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n.sidebarLogo img {\n  width: 180px;\n  height: 100px;\n  object-fit: contain;\n}\n\n.sideBarTabContainer {\n  display: flex;\n  overflow-y: auto;\n  flex-direction: column;\n  flex: 1;\n  min-height: 0;\n  scrollbar-width: thin;\n  scrollbar-color: var(--primary-color) rgba(0, 0, 0, 0.05);\n}\n\n.sideBarTabContainer::-webkit-scrollbar {\n  width: 6px;\n}\n\n.sideBarTabContainer::-webkit-scrollbar-track {\n  background: rgba(0, 0, 0, 0.05);\n  border-radius: 10px;\n}\n\n.sideBarTabContainer::-webkit-scrollbar-thumb {\n  background: var(--primary-color);\n  border-radius: 10px;\n}\n\n.sideBarTabContainer::-webkit-scrollbar-thumb:hover {\n  background: #a0080b;\n}\n\n.sideBarTab {\n  display: flex;\n  padding: 10px 15px;\n  margin-right: 16px;\n  align-items: center;\n  gap: 10px;\n}\n\n.sideBarTab[data-active=\"true\"] {\n  background: var(--primary-color);\n  border-radius: 7px;\n  box-shadow: 0px 7px 30px 0px #3745571a;\n}\n\n.sideBarTab[data-active=\"true\"] p {\n  color: var(--white-color);\n}\n\n.sideBarTab p {\n  color: var(--gray-v5);\n  font-family: \"Inter\", serif;\n  font-size: 16px;\n  font-weight: 500;\n  margin-bottom: 0px;\n}\n\n.sideBarTabIcon {\n  display: flex;\n  width: 25px;\n  height: 25px;\n  justify-content: center;\n  align-items: center;\n  border-radius: 5px;\n  border: 1px solid var(--purple-v1);\n  background: #fff;\n}\n\n.logoutBtn {\n  background-color: var(--primary-color);\n  color: var(--white-color);\n  display: flex;\n  height: 45px;\n  align-items: center;\n  border-radius: 7px;\n  gap: 10px;\n  cursor: pointer;\n  margin: 0px 10px 20px;\n}\n\n.logoutBtn svg,\n.logoutBtn span {\n  color: var(--white-color);\n}\n\n@media screen and (max-width: 1024px) {\n  .sideBarTabContainer {\n    gap: 10px;\n  }\n\n  .sideBarTab p {\n    font-size: 13px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"sideBar": `Sidebar_sideBar__eaJIk`,
	"sidebarLogo": `Sidebar_sidebarLogo__dCHQt`,
	"sideBarTabContainer": `Sidebar_sideBarTabContainer__aiZKJ`,
	"sideBarTab": `Sidebar_sideBarTab__RhKkR`,
	"sideBarTabIcon": `Sidebar_sideBarTabIcon__Gm5dy`,
	"logoutBtn": `Sidebar_logoutBtn__lBM+V`
};
export default ___CSS_LOADER_EXPORT___;
